module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_ockero-daefff3a6639a993177994ea2c49eb6c.png";